{
	"searchCollections": "Search collections",
	"noCollectionsMatch": "No collections match your search",
	"noGalleriesMatch": "No galleries match your search",
	"noOtherGalleriesMatch": "No other galleries match your search",
	"failedToLoad": "Unable to load collections. Please try again.",
	"retry": "Try again",
	"ariaViewCollection": "View {{name}} collection",
	"createCollection": "Create Collection",
	"createCollectionTitle": "Create Collection",
	"delinquentAccount": "Your account is delinquent. Please manage your billing to continue using Pixieset features.",
	"failedToCreateCollectionPlease": "Failed to create collection. Please try again.",
	"failedToCreateTitle": "Failed to create collection",
	"manageBilling": "Manage Billing",
	"noGalleries": "No Pixieset galleries yet",
	"otherCollections": "Other Collections",
	"selectedCollection": "Selected Collection",
	"view": "View"
}
